import React, { useEffect } from 'react';
import ui from 'stores/ui';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import Title from 'components/Title';
import URL from 'utils/URL';
import withSSR, { SSRProps } from 'utils/withSSR';
import store from './store';
import './style.scss';

const Agreements: React.FC<
    SSRProps<{
        data: any;
    }>
> = props => {
    useEffect(() => {
        ui.setPid('agreement');
        ui.setClearMode(true);

        return () => ui.setClearMode(false);
    }, []);

    function render() {
        const { __error__, __loading__, __getData__, data } = props;

        if (__loading__) {
            return <Loading className="site-load-loading" />;
        }

        if (__error__) {
            return <ErrorBox error={__error__} onClick={__getData__} />;
        }

        return <div className="content" dangerouslySetInnerHTML={{ __html: data }} />;
    }

    return (
        <div className="site-main agreement">
            <Title title="Agreements & Disclosures" hasTiger={false} />
            {render()}
        </div>
    );
};

export default withSSR(Agreements, async props => {
    const { params, path } = props.match;
    const isAgreement = path.startsWith('/agreement') ? true : false;
    const legal_version: string | string[] | undefined =
        typeof window === 'undefined'
            ? (props.request?.query?.legal_version as any)
            : URL.current().query.legal_version;
    const data = await store.getAgreement(
        params.id,
        isAgreement,
        Array.isArray(legal_version) ? legal_version[0] : legal_version
    );

    return {
        data
    };
});
